<template>
  <div>
    <modal-vue class="col-lg-12">
      <div slot="header">
        <h3>Novo tópico</h3>
      </div>

      <div slot="body" style="margin:0px;">
        <textarea v-model="newtopic.text" style="width:100%" rows="9"></textarea>
      </div>

      <div slot="footer">
        <lms-button :disabled="saving" @click="save()" :loading="saving">Salvar</lms-button>
        <lms-button class="btn-danger" :disabled="false" @click="close()" :loading="false">Fechar</lms-button>
      </div>
    </modal-vue>
  </div>
</template>


<style lang="scss" scoped>
</style>


<script>
import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  props: {
    newtopic: {
      type: Object,
      required: false,
      default: function() {
        return {  };
      }
    }
  },
  data() {
    return {
      saving:false
    };
  },
  methods: {
    save() {
      console.log('aasasdasdas');
      this.saving = true;
      const path = this.$global.endpoint + "/forum/topic/save";
      axios
        .post(path, {
          topic: this.newtopic
        })
        .then(res => {
          this.saving = false;
          this.$notify({
            type: "success",
            group: "foo",
            title: "Concluído",
            text: "Tópico cadastrado com sucesso"
          });
          this.$emit("close");
        })
        .catch(error => {
          this.saving = false;
          console.error(error);
          this.$notify({
            type: "error",
            group: "foo",
            title: "Erro",
            text: error.response.data.error
          });
        });
    },
    close() {
      this.$emit("close");
    }
  },
  created() {}
};
</script>
